import { useContext } from 'react';
import { SaveObjectAccessContext } from '../Context';

export const useSaveObjectAccess = () => {
  const save = useContext(SaveObjectAccessContext);

  return save;
};

export default useSaveObjectAccess;